import React, { useState } from 'react'
import { ReservationSearchFilters, ReservationSearchFormProps } from '../../Types/reservationTypes';
import { reservationValuesSearch } from './initialValues';

import { useGetReservationsFilterSelectsQuery } from '../../Service/extendedReservationsApi';
import { fieldsSearch } from './fieldsSearch';
import { IdNameDto } from '../../../Shared/Types/common';
import SearchFormWrapper from '../../../Shared/Components/SearchFormWrapper';
import { useFieldsWithFilterOptions } from '../../../Shared/Hooks/useFieldsWithOptions';

const ReservationSearchForm = ({ onSearch }: ReservationSearchFormProps) => {
    const [filters, setFilters] = useState(reservationValuesSearch);
    const { data: filterData } = useGetReservationsFilterSelectsQuery()
    const fieldToFilterKey = {
        offerId: "offers",
    };
    const fields = useFieldsWithFilterOptions(
        fieldsSearch, (filterData as unknown as Record<string, IdNameDto[]>) ?? {}, fieldToFilterKey
    ) as unknown as typeof fieldsSearch;
    const handleSearch = (values: Record<string, string>) => {
        setFilters(values as unknown as ReservationSearchFilters);
        onSearch({
            createdAt: values.createdAt,
            offerId: values.offerId ? parseInt(values.offerId).toString() : "",
            source: values.source,
            applicantFirstName: values.applicantFirstName,
            applicantLastName: values.applicantLastName,
            applicantEmail: values.applicantEmail,
        });
    };

    return (
        <SearchFormWrapper
            fields={fields}
            initialValues={filters as unknown as Record<string, string>}
            onSubmit={handleSearch}
        />
    );
};

export default ReservationSearchForm


